export default __webpack_public_path__ + "static/media/2050.72f789eb.png";